import React from "react";
// import { Select } from "../Select";
import { AttributeItem } from "./interfacesAttr";
// import styled from "styled-components";
import { DateInput } from "../inputs/DateInput";
import { CheckboxGroup } from "../inputs/Checkbox";
import { Input } from "../inputs/Input";
import { AutocompleteInputCustom } from "../inputs/AutocompleteInputCustom";
import { MoneyInput } from "../inputs/MoneyInput";
import { TextareaInput } from "../inputs/TextareaInput";

const SelectComponent: React.FC<any> = (props) => {
  const optionsCount = props.options ? Object.keys(props.options).length : 0;

  if (optionsCount > 6) {
    const autocompleteOptions = props.options
      ? Object.entries(props.options).map(([key, val]) => ({
          id: key,
          title: String(val),
          alias: key,
        }))
      : [];

    return (
      <AutocompleteInputCustom
        {...props}
        options={autocompleteOptions}
        value={props.value}
        onChange={(opt) => {
          if (props.radio) {
            props.onChange(opt ? String((opt as any).id) : "");
          } else {
            props.onChange(opt ? [String((opt as any).id)] : []);
          }
        }}
      />
    );
  }

  return <CheckboxGroup {...props} />;
};

export const ATTRIBUTE_COMPONENTS: Record<string, React.FC<any>> = {
  string: Input,
  text: Input,
  number: (props) => (
    <Input
      {...props}
      type="number"
    />
  ),
  money:(props) => (
    <MoneyInput
      {...props}
      type="money"
    />
  ),
    textarea: (props) => <TextareaInput {...props} />,


  date: (props) => <DateInput {...props} />,
  radio: (props) => <SelectComponent {...props} single radio />,
  select: SelectComponent,

  default: (props) => (
    <Input {...props}  />
  ),
};

export const AttributeFactory: React.FC<{
  item: AttributeItem;
  handleUpdate: any;
  border: boolean;
  labelStyle?: React.CSSProperties;
}> = ({ item, handleUpdate, border, labelStyle }) => {
  const typeKey = item.type?.alias.toLowerCase();
  const Component =
    ATTRIBUTE_COMPONENTS[typeKey] || ATTRIBUTE_COMPONENTS["default"];

  const normalizeOptions = (data: any): Record<string, string> | null => {
    if (!data) return null;
    if (!Array.isArray(data) && typeof data === "object") return data;

    if (Array.isArray(data)) {
      return Object.fromEntries(
        data.map((item: any) => [
          String(item.id),
          item.title ?? String(item.id),
        ]),
      );
    }

    return null;
  };
  const normalizeValue = () => {
    if (!item.value) return "";

    if (Array.isArray(item.data)) {
      const found = item.data.find((d: any) => d.title === item.value);

      return found ? String(found.id) : String(item.value);
    }

    return item.value;
  };

  return (
    <Component
      label={item.title}
      value={normalizeValue()}
      onChange={(newValue: any) =>
        handleUpdate(item.id, newValue, item.type.alias)
      }
      id={item.id}
      options={normalizeOptions(item.data)}
      border={border}
      labelStyle={labelStyle}
    />
  );
};
